import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../asyncInterface";

function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.adminSearchResult.fetchAccountData(fetchPayload);
}

function* fetchAdminSearchResults(data) {
  yield put({ type: "GET_ADMINSEARCH_LOADING" });
  try {
    const response = yield call(fetchAccountData, data);

    yield put({
      type: "GET_ADMIN_SEARCH_RESULTS_SUCCESS",
      payload: response
    });
  } catch (error) {
    yield put({
      type: "GET_ADMIN_SEARCH_RESULTS_ERROR",
      payload: "ERROR"
    });
  }
}
function* fetchAdminSearchWorker(fetchPayload) {
  yield all([fork(fetchAdminSearchResults, fetchPayload.payload[0])]);
}
function* fetchAdminSearchWatcher() {
  yield takeEvery("FETCH_ADMIN_SEARCH_RESULTS", fetchAdminSearchWorker);
}
export default function* AdminSearch() {
  yield all([fork(fetchAdminSearchWatcher)]);
}
